<!-- Modal Title -->
<div *nzModalTitle class="font-600">
	{{ "global.common.organization_profile" | translate }}
</div>


<div class="scrollable-content">
	<div class="main-container">
		<!-- <div>
			<img nz-image width="400px" height="400px" [nzSrc]="organizationDetails.organization.profileUrl"
				nzFallback="../../../../assets/product_rocket.svg" alt="" />
		</div> -->
		<div>
			<app-image-with-loading width="400" height="400" [productImages]="profileUrl" [index]="0" [isProfile]="true">
			</app-image-with-loading>
		</div>

		<div class="content-container">
			<div>
				<div class="mb-0_5">
					<span class="info-label"> {{ 'global.common.organization_name' | translate }}: </span>
					<span class="info-value"> {{ organizationDetails.organization.name }} </span>
				</div>
				<div class="mb-0_5">
					<span class="info-label"> {{ 'global.common.rating' | translate }}: </span>
					<nz-rate class="ratingDiv" [ngModel]="organizationDetails.organization.ratings" nzAllowHalf nzDisabled></nz-rate>
				</div>
				<div class="mb-0_5">
					<span class="info-label"> {{ 'global.common.website' | translate }}: </span>
					<span class="info-value"> {{ organizationDetails.organization.website }} </span>
				</div>
				<div class="mb-0_5">
					<span class="info-label"> {{ 'global.common.vat' | translate }}: </span>
					<span class="info-value"> {{ organizationDetails.organization.vat }} </span>
				</div>
				<div class="mb-0_5">
					<span class="info-label"> {{ 'global.common.commercial_register_number' | translate }}: </span>
					<span class="info-value"> {{ organizationDetails.organization.commercialRegisterNumber }} </span>
				</div>
				<div class="mb-0_5">
					<span class="info-label">{{ 'global.common.address' | translate }}:</span>
					<span class="info-value">{{ organizationDetails?.address[0]?.street }}, {{ organizationDetails?.address[0]?.zip }},{{ organizationDetails?.address[0]?.state }}, {{ organizationDetails?.address[0]?.country }}</span>
				</div>
				<div class="mb-0_5">
					<span class="info-label"> {{ 'global.common.contactName' | translate }}: </span>
					<span class="info-value">{{ organizationDetails?.firstName }} {{ organizationDetails?.lastName }}</span>
				</div>
				<div class="mb-0_5">
					<span class="info-label"> {{ 'global.common.contactEmail' | translate }}: </span>
					<span class="info-value">{{ organizationDetails?.email }}</span>
				</div>
				<div class="mb-0_5">
					<span class="info-label"> {{ 'global.common.phoneNumber' | translate }}: </span>
					<span class="info-value">{{ organizationDetails?.phone }}</span>
				</div>
			
				
			</div>
		</div>
	</div>

	<div class="mb-1 mt-2">
		<label>
			<span class="info-label"> {{ 'global.common.about_company' | translate }}: </span>
		</label>
		<div class="description-content">
			<div class="mb-0_5">
				<span class="info-value"> {{ organizationDetails.organization.description }} </span>
			</div>
		</div>
	</div>
</div>
